module.exports = __webpack_public_path__ + "static/media/create-post.bdd0d54f.svg";